import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class DesignSystem extends Page{
    constructor(){
        super({
            id : 'home',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}